import { render } from "./ProjectsView.vue?vue&type=template&id=4b9bcd1e&ts=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__